import { useEffect, useState } from "react";
import ReactDOM from "react-dom";

interface IPortalProps {
  children: React.ReactElement;
}

const Portal = ({ children }: IPortalProps) => {
  const [container] = useState(() => document.createElement("div"));

  useEffect(() => {
    document.documentElement.appendChild(container);
    return () => {
      document.documentElement.removeChild(container);
    };
  }, []);

  return ReactDOM.createPortal(children, container);
};

export default Portal;
